import React, { useState, useEffect } from 'react';
import { BASEAPIURL, token } from '../../env';
import LawnManagement from './LawnMangement';

const SportsSlot = () => {
  // =================== STATE ===================
  const [slots, setSlots] = useState([]);
  const [courts, setCourts] = useState([]);
  const [lawnSlots, setLawnSlots] = useState([]);

  const [loading, setLoading] = useState(true);
  const [loadingCourts, setLoadingCourts] = useState(false);
  const [loadingLawnSlots, setLoadingLawnSlots] = useState(false);
  const [error, setError] = useState(null);

  const [activeTab, setActiveTab] = useState('Hall');

  const [showForm, setShowForm] = useState(false);
  const [showLawnSlotForm, setShowLawnSlotForm] = useState(false);

  const [isEditing, setIsEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [savingLawnSlot, setSavingLawnSlot] = useState(false);

  const [currentSlot, setCurrentSlot] = useState({
    SlotID: null,
    SlotName: '',
    Duration: '',
    CourtID: '',
    PlayerAllowed: '4',
    MemberPrice: '',
    GuestPrice: '',
    BookingAllowed: 'Yes',
  });

  const [currentLawnSlot, setCurrentLawnSlot] = useState({
    SlotID: null,
    SlotName: '',
    SlotStart: '',
    SlotEnd: '',
    Type: 'Lawn',
  });

  const TOKEN_DATA = token;
 

  // =================== FETCH DATA ===================
  const fetchSlots = async () => {
    setLoading(true);
    setError(null);
    try {
      const url = `${BASEAPIURL}/GetLawnTimeslot?type=Hall&Token=${encodeURIComponent(TOKEN_DATA)}`;
      const response = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const result = await response.json();
      if (result.status && Array.isArray(result.data)) {
        setSlots(result.data);
      } else {
        setError(result.error || 'Failed to load banquet hall slots');
        setSlots([]);
      }
    } catch (err) {
      setError(err.message || 'Network error');
    } finally {
      setLoading(false);
    }
  };

  const fetchCourts = async () => {
    setLoadingCourts(true);
    try {
      const response = await fetch(`${BASEAPIURL}/GetFacilityCourts?Token=${encodeURIComponent(TOKEN_DATA)}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch (e) {
        console.error('Invalid JSON from GetCourts', e);
        return;
      }
      if (data.status && Array.isArray(data.data)) {
        setCourts(data.data);
      } else {
        setCourts([]);
      }
    } catch (err) {
      console.error('Fetch Halls Error:', err);
      setCourts([]);
    } finally {
      setLoadingCourts(false);
    }
  };

  const fetchLawnSlots = async () => {
    setLoadingLawnSlots(true);
    try {
      const url = `${BASEAPIURL}/GetLawnTimeslot?type=Lawn&Token=${TOKEN_DATA}`;
      const response = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      const result = await response.json();
      if (result.status && Array.isArray(result.data)) {
        setLawnSlots(result.data);
      } else {
        setLawnSlots([]);
      }
    } catch (err) {
      console.error('Failed to fetch lawn time slots:', err);
      setLawnSlots([]);
    } finally {
      setLoadingLawnSlots(false);
    }
  };

  useEffect(() => {
    fetchSlots();
    fetchCourts();
    fetchLawnSlots();
  }, []);

  // =================== HANDLE INPUTS ===================
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setCurrentSlot((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? (checked ? 'Yes' : 'No') : value,
    }));
  };

  const handleLawnSlotChange = (e) => {
    const { name, value } = e.target;
    setCurrentLawnSlot((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // =================== BANQUET HALL SLOT: ADD / EDIT ===================
  const handleAdd = () => {
    setCurrentSlot({
      SlotID: null,
      SlotName: '',
      Duration: '',
      CourtID: '',
      PlayerAllowed: '4',
      MemberPrice: '',
      GuestPrice: '',
      BookingAllowed: 'Yes',
    });
    setIsEditing(false);
    setShowForm(true);
  };

  const [showBanquetSlotForm, setShowBanquetSlotForm] = useState(false);
  const [currentBanquetSlot, setCurrentBanquetSlot] = useState({
    Lawn_ID: "",
    Lawn_Name: "",
    BookingCount: "",
    Type: "Hall",
    FacilityID: ""
  });

  const [facilities, setFacilities] = useState([]);
  const [loadingFacilities, setLoadingFacilities] = useState(false);
  const [savingBanquetSlot, setSavingBanquetSlot] = useState(false);

  const handleBanquetSlotChange = (e) => {
    const { name, value, type, checked } = e.target;
    setCurrentBanquetSlot((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? (checked ? "Yes" : "No") : value
    }));
  };

  useEffect(() => {
    const fetchFacilities = async () => {
      try {
        setLoadingFacilities(true);
        const res = await fetch("YOUR_GET_FACILITY_API_URL");
        const data = await res.json();
        setFacilities(data);
      } catch (err) {
        console.error("Failed to fetch facilities", err);
      } finally {
        setLoadingFacilities(false);
      }
    };
    fetchFacilities();
  }, []);

  const handleSubmitBanquetSlot = async (e) => {
    e.preventDefault();
    setSavingBanquetSlot(true);

    try {
      const res = await fetch(`${BASEAPIURL}/UpdateLawsTimeslot?MainID=2`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(currentBanquetSlot)
      });

      if (!res.ok) throw new Error("Failed to save banquet slot");

      setShowBanquetSlotForm(false);
      setCurrentBanquetSlot({
        Lawn_ID: "",
        Lawn_Name: "",
        BookingCount: "",
        Type: "Hall",
        FacilityID: ""
      });
    } catch (err) {
      console.error(err);
    } finally {
      setSavingBanquetSlot(false);
    }
  };

  // =================== LAWN TIME SLOT: ADD / EDIT ===================
  const handleAddLawnSlot = () => {
    setCurrentLawnSlot({
      SlotID: null,
      SlotName: '',
      SlotStart: '',
      SlotEnd: '',
      Type: 'Lawn',
    });
    setIsEditing(false);
    setShowLawnSlotForm(true);
  };

  const handleAddHallSlot = () => {
    setCurrentLawnSlot({
      SlotID: null,
      SlotName: '',
      SlotStart: '',
      SlotEnd: '',
      Type: 'Hall',
    });
    setIsEditing(false);
    setShowLawnSlotForm(true);
  };

  const handleEditLawnSlot = (slot) => {
    setCurrentLawnSlot({
      SlotID: slot.SlotID,
      SlotName: slot.SlotName || '',
      SlotStart: convertTo24Hour(slot.SlotStart) || '',
      SlotEnd: convertTo24Hour(slot.SlotEnd) || '',
      Type: slot.Type || 'Lawn',
    });
    setIsEditing(true);
    setShowLawnSlotForm(true);
  };

  const convertTo24Hour = (timeStr) => {
    if (!timeStr) return '';
    const d = new Date(`2000-01-01 ${timeStr}`);
    return isNaN(d) ? '' : d.toTimeString().slice(0, 5);
  };

  const handleSubmitLawnSlot = async (e) => {
    e.preventDefault();
    const { SlotID, SlotName, SlotStart, SlotEnd } = currentLawnSlot;

    if (!SlotName.trim() || !SlotStart || !SlotEnd) {
      alert('Slot Name, Start, and End times are required.');
      return;
    }

    setSavingLawnSlot(true);

    const slotData = {
      SlotName: SlotName.trim(),
      SlotStart,
      SlotEnd,
      Type: currentLawnSlot.Type,
    };

    const payload = {
      tokenData: TOKEN_DATA,
      lawnSlot: slotData,
    };

    try {
      const endpoint = SlotID
        ? `${BASEAPIURL}/UpdateLawnTimeslot?MainID=${SlotID}`
        : `${BASEAPIURL}/InsertLawnTimeslot`;

      const response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (result.status) {
        alert(`✅ Lawn time slot ${SlotID ? "updated" : "added"} successfully!`);
        setShowLawnSlotForm(false);
        fetchLawnSlots();
      } else {
        throw new Error(result.error || "Failed to save");
      }
    } catch (err) {
      console.error("Error saving lawn time slot:", err);
      alert(`❌ Error: ${err.message}`);
    } finally {
      setSavingLawnSlot(false);
    }
  };

  // =================== RENDER ===================
  if (error) {
    return (
      <div className="alert alert-danger m-1">
        ❌ {error}
        <button className="btn btn-sm btn-outline-danger ms-2" onClick={fetchSlots}>
          Retry
        </button>
      </div>
    );
  }

  if (loading && !loadingCourts && !loadingLawnSlots) {
    return <div className="text-center py-2">🔄 Loading data...</div>;
  }

  return (
    <div className="p-1">
      {/* Tabs */}
      <ul className="nav nav-tabs mb-2">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'Hall' ? 'active' : ''}`}
            onClick={() => {
              setActiveTab('Hall')
              fetchSlots()
            }}
            type="button"
          >
            🏛️ Hall
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'lawnSlots' ? 'active' : ''}`}
            onClick={() => {
              setActiveTab('lawnSlots');
              fetchLawnSlots();
            }}
            type="button"
          >
            🏕️ Lawn
          </button>
        </li>
      </ul>

      {/* =================== BANQUET HALL SLOTS TAB =================== */}
      {activeTab === 'Hall' && (
        <div>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h5 className="mb-0">🏛️ Hall Timeslot Configuration</h5>
            <button className="btn btn-sm btn-success" onClick={handleAddHallSlot}>
              <i className="bi bi-plus-circle me-1"></i>Add
            </button>
          </div>

          {slots.length === 0 ? (
            <div className="alert alert-info text-center p-2">📭 No slots available.</div>
          ) : (
            <div className="table-responsive mb-2">
              <table className="table table-bordered table-sm align-middle">
                <thead className="table-dark">
                  <tr>
                    <th>#</th>
                    <th>Slot</th>
                    <th>Start</th>
                    <th>End</th>
                    <th>Type</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {slots.map((slot, i) => (
                    <tr key={slot.SlotID}>
                      <td>{i + 1}</td>
                      <td><strong>{slot.SlotName}</strong></td>
                      <td><code>{slot.SlotStart}</code></td>
                      <td><code>{slot.SlotEnd}</code></td>
                      <td><span className="badge bg-secondary">{slot.Type}</span></td>
                      <td>
                        <button
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => handleEditLawnSlot(slot)}
                        >
                          ✏️ Edit
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <div>
            <LawnManagement type="Hall" />
          </div>
        </div>
      )}

      {/* =================== LAWN TIME SLOTS TAB =================== */}
      {activeTab === 'lawnSlots' && (
        <div>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h5 className="mb-0">🏕️ Lawn Timeslot Configuration</h5>
            <button className="btn btn-sm btn-success" onClick={handleAddLawnSlot}>
              <i className="bi bi-plus-circle me-1"></i>Add
            </button>
          </div>

          {loadingLawnSlots ? (
            <div className="text-center py-1">🔄 Loading...</div>
          ) : lawnSlots.length === 0 ? (
            <div className="alert alert-warning text-center p-2">📭 No slots found.</div>
          ) : (
            <div className="table-responsive mb-2">
              <table className="table table-bordered table-sm align-middle">
                <thead className="table-dark">
                  <tr>
                    <th>#</th>
                    <th>Slot</th>
                    <th>Start</th>
                    <th>End</th>
                    <th>Type</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {lawnSlots.map((slot, i) => (
                    <tr key={slot.SlotID}>
                      <td>{i + 1}</td>
                      <td><strong>{slot.SlotName}</strong></td>
                      <td><code>{slot.SlotStart}</code></td>
                      <td><code>{slot.SlotEnd}</code></td>
                      <td><span className="badge bg-secondary">{slot.Type}</span></td>
                      <td>
                        <button
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => handleEditLawnSlot(slot)}
                        >
                          ✏️ Edit
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <div>
            <LawnManagement type="Lawn" />
          </div>
        </div>
      )}

      {/* =================== MODALS =================== */}
      <ModalOverlay show={showBanquetSlotForm} onClose={() => setShowBanquetSlotForm(false)}>
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <form onSubmit={handleSubmitBanquetSlot}>
              <div className="modal-header p-2">
                <h5 className="modal-title">
                  {isEditing ? '✏️ Edit' : '➕ Add'} Hall
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowBanquetSlotForm(false)}
                ></button>
              </div>

              <div className="modal-body p-2">
                <div className="mb-2">
                  <label className="form-label small">Name *</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="Lawn_Name"
                    value={currentBanquetSlot.Lawn_Name}
                    onChange={handleBanquetSlotChange}
                    placeholder="e.g. Ashok Lawn"
                    required
                  />
                </div>

                <div className="mb-2">
                  <label className="form-label small">Guests *</label>
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    name="BookingCount"
                    value={currentBanquetSlot.BookingCount}
                    onChange={handleBanquetSlotChange}
                    min="1"
                    required
                  />
                </div>

                <div className="mb-2">
                  <label className="form-label small">Type *</label>
                  <select
                    className="form-select form-select-sm"
                    name="Type"
                    value={currentBanquetSlot.Type}
                    onChange={handleBanquetSlotChange}
                    required
                  >
                    <option value="">-- Select --</option>
                    <option value="Hall">Banquet Hall</option>
                    <option value="Lawn">Lawn</option>
                  </select>
                </div>

                <div className="mb-2">
                  <label className="form-label small">Facility *</label>
                  {loadingFacilities ? (
                    <div className="form-control text-muted small">Loading...</div>
                  ) : facilities.length === 0 ? (
                    <div className="form-control text-danger small">No facilities</div>
                  ) : (
                    <select
                      className="form-select form-select-sm"
                      name="FacilityID"
                      value={currentBanquetSlot.FacilityID || ''}
                      onChange={handleBanquetSlotChange}
                      required
                    >
                      <option value="">-- Select --</option>
                      {facilities.map((facility) => (
                        <option key={facility.FacilityID} value={facility.FacilityID}>
                          {facility.FacilityName}
                        </option>
                      ))}
                    </select>
                  )}
                </div>
              </div>

              <div className="modal-footer p-2">
                <button
                  type="button"
                  className="btn btn-sm btn-secondary"
                  onClick={() => setShowBanquetSlotForm(false)}
                  disabled={savingBanquetSlot}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-sm btn-success"
                  disabled={savingBanquetSlot}
                >
                  {savingBanquetSlot ? 'Saving...' : isEditing ? 'Update' : 'Add'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </ModalOverlay>

      {/* =================== LAWN TIME SLOT MODAL =================== */}
      <ModalOverlay show={showLawnSlotForm} onClose={() => setShowLawnSlotForm(false)}>
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <form onSubmit={handleSubmitLawnSlot}>
              <div className="modal-header p-2">
                <h5 className="modal-title">
                  {isEditing ? '✏️ Edit' : '➕ Add'} Slot
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowLawnSlotForm(false)}
                ></button>
              </div>
              <div className="modal-body p-2">
                <div className="mb-2">
                  <label className="form-label small">Slot Name *</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="SlotName"
                    value={currentLawnSlot.SlotName}
                    onChange={handleLawnSlotChange}
                    placeholder="e.g. Full Day"
                    required
                  />
                </div>
                <div className="mb-2">
                  <label className="form-label small">Start *</label>
                  <input
                    type="time"
                    className="form-control form-control-sm"
                    name="SlotStart"
                    value={currentLawnSlot.SlotStart}
                    onChange={handleLawnSlotChange}
                    required
                  />
                </div>
                <div className="mb-2">
                  <label className="form-label small">End *</label>
                  <input
                    type="time"
                    className="form-control form-control-sm"
                    name="SlotEnd"
                    value={currentLawnSlot.SlotEnd}
                    onChange={handleLawnSlotChange}
                    required
                  />
                </div>
              </div>
              <div className="modal-footer p-2">
                <button
                  type="button"
                  className="btn btn-sm btn-secondary"
                  onClick={() => setShowLawnSlotForm(false)}
                  disabled={savingLawnSlot}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-sm btn-success"
                  disabled={savingLawnSlot}
                >
                  {savingLawnSlot ? 'Saving...' : isEditing ? 'Update' : 'Add'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </ModalOverlay>
    </div>
  );
};

// Reusable Modal Overlay Component
const ModalOverlay = ({ children, show, onClose }) => {
  if (!show) return null;
  return (
    <>
      <div
        className="modal-backdrop fade show"
        style={{ display: 'block' }}
        onClick={onClose}
      ></div>
      <div
        className="modal fade show"
        style={{ display: 'block' }}
        tabIndex="-1"
      >
        {children}
      </div>
    </>
  );
};

export default SportsSlot;